import type { RevenueCatInitStatus } from '../../../hooks/revenuecat-init-controller'

export type PurchaseOfferingsStatus = 'ready' | 'empty'

export type PurchaseOptionsViewState =
  | 'loading'
  | 'init_failed'
  | 'ready'
  | 'empty'

interface ResolvePurchaseOptionsViewStateParams {
  isSessionLoading: boolean
  revenueCatInitStatus: RevenueCatInitStatus
  offeringsStatus?: PurchaseOfferingsStatus
}

export function resolvePurchaseOptionsViewState({
  isSessionLoading,
  revenueCatInitStatus,
  offeringsStatus,
}: ResolvePurchaseOptionsViewStateParams): PurchaseOptionsViewState {
  if (
    isSessionLoading ||
    revenueCatInitStatus === 'idle' ||
    revenueCatInitStatus === 'initializing' ||
    revenueCatInitStatus === 'identifying'
  ) {
    return 'loading'
  }

  if (revenueCatInitStatus === 'failed') {
    return 'init_failed'
  }

  return offeringsStatus === 'empty' ? 'empty' : 'ready'
}
